import { render } from "./ItemFilters.vue?vue&type=template&id=08be5c41&scoped=true"
import script from "./ItemFilters.vue?vue&type=script&lang=js"
export * from "./ItemFilters.vue?vue&type=script&lang=js"

import "./ItemFilters.vue?vue&type=style&index=0&id=08be5c41&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08be5c41"]])

export default __exports__